'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

import { DynamicProductPageLatestActivity } from './DynamicProductPageLatestActivity'

const ProductPageLatestActivity: FC = () => {
  const { isIntersecting, ref } = useIntersectionObserver({
    freezeOnceVisible: true,
  })

  return (
    <div
      className={clsx(isIntersecting && 'mt-5')}
      data-qa-id="last-activity-container"
      ref={ref}
    >
      {isIntersecting ? <DynamicProductPageLatestActivity /> : null}
    </div>
  )
}

export { ProductPageLatestActivity }
